export default {
    1: '1_Geochemistry_Department_of_Lomonosov_MSU',
    2: '2_IncertoData',
    3: '3_IGT',
    4: '4_Abrax',
    8: '8_Incaic_Exploration',
    9: '9_Avant_Data_Solutions',
    10: '10_TerraNibble',
    11: '11_Jack_Maughan',
    12: '12_Deakin_University__Data_Analytics_Minor_Thesis',
    13: '13_Eureka_Maps',
    17: '17_Federal_Fluminense_University_(UFF)',
    19: '19_Sam_Bost__SIG_Machine_Learning',
    22: '22_Team_Campbell',
    23: '23_LanXiang',
    26: '26_GeoAnalysis_AbhishekS',
    30: '30_Caldera_Analytics',
    33: '33_Sparveon',
    36: '36_Minefield',
    37: '37_Grizzly_Bear',
    38: '38_DeMIST',
    41: '41_DeepSightX',
    46: '46_Depex',
    50: '50_UniLaSalle_Fr',
    51: '51_EnerZai',
    52: '52_Omega_Key',
    53: '53_Austrike',
    54: '54_Per-Oz',
    56: '56_I-PURWA',
    57: '57_Team_Jupiter',
    59: '59_Archimedes_Consortium'
};
